import { ModalKey } from 'modules/modal/state/modal-types'
import MissingDigitalPaymentInfoFallbackModalPanel from './missing-digital-payment-info-fallback-modal-panel'

export const modalKeyToComponentMap: { [key in ModalKey]: React.ComponentType } = {
  'missing-digital-payment-info-fallback': MissingDigitalPaymentInfoFallbackModalPanel,
}

export const focusOnElement = (dataId: string) => {
  return () => {
    const openerButton = document.querySelector(`[data-id="${dataId}"]`) as HTMLElement

    if (openerButton) {
      openerButton.focus()
    }
  }
}
